import IconNamesType from 'presentation/icons/IconNamesType';

const API_FEATURE_ICON: IconNamesType = 'check-default';

const TWO_COLUMNS_LAYOUT = {iconSize: 32, contentColumns: 12};
const SINGLE_COLUMN_LAYOUT = {iconSize: 22, contentColumns: 10};

export {API_FEATURE_ICON, SINGLE_COLUMN_LAYOUT, TWO_COLUMNS_LAYOUT};
